export const pluralize = (word: string, count: number | null | undefined) =>
  count === 1 ? word : `${word}s`;
